export default "__VITE_ASSET__CZnKOolc__"